import * as D from '../deps';

export function acceptFamilyPlanInvite({ inviteToken }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_ACCEPT_INVITE,
    content: {
      inviteToken,
    },
  });
}
